module.exports = new __parcel__URL__("decision-dark.3127b35c.svg").toString();